import _ from 'lodash';
import PropTypes from 'prop-types';
import { EXTERNAL_SIGNALS_VENDOR_TYPES } from 'v2/common/constants/index';
import ToggleGroupButton from 'v3/common/components/ToggleGroupButton';

const propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onUpdatePipeConfig: PropTypes.func.isRequired
};
const VendorField = ({
  name: propsName, value, onUpdatePipeConfig
}) => {

  const toggleOptions = _.map(EXTERNAL_SIGNALS_VENDOR_TYPES, (vendorType) => ({
    label: vendorType,
    value: vendorType,
    onClick: () => onUpdatePipeConfig(propsName, vendorType),
  }));

  return (
    <div className='external-vendor-type'>
      <ToggleGroupButton 
        options={toggleOptions} 
        defaultValue={value}
        style="rounded w-100"
       />
    </div>
  );
};

VendorField.propTypes = propTypes;

export default VendorField;
